(() => {
  const opens = document.querySelectorAll('[data-digi-value-open]');
  const closes = document.querySelectorAll('[data-digi-value-close]');
  const modals = document.querySelectorAll('[data-digi-value-modal]');

  if (!opens.length || !modals.length) return;

  function openModal(id) {
    const modal = document.querySelector(`[data-digi-value-modal="${id}"]`);
    if (!modal) return;

    modal.classList.add('is-open');
    document.documentElement.classList.add('digi-value-modal-open');
  }

  function closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');

    const hasOpenModal = document.querySelector('[data-digi-value-modal].is-open');
    if (!hasOpenModal) {
      document.documentElement.classList.remove('digi-value-modal-open');
    }
  }

  opens.forEach((button) => {
    button.addEventListener('click', () => {
      openModal(button.dataset.digiValueOpen);
    });
  });

  closes.forEach((button) => {
    button.addEventListener('click', () => {
      closeModal(button.closest('[data-digi-value-modal]'));
    });
  });

  modals.forEach((modal) => {
    modal.addEventListener('click', (event) => {
      if (event.target === modal) {
        closeModal(modal);
      }
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;

    const modal = document.querySelector('[data-digi-value-modal].is-open');
    closeModal(modal);
  });
})();
